import { Component, OnInit } from '@angular/core';
import { AimsCommonPopupEditorData } from '@aims/common-components';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { FormControl, Validators } from '@angular/forms';
import { delay, tap } from 'rxjs/operators';
import { NgComponents } from 'src/models';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-component-registration-popup',
  templateUrl: './component-registration-popup.component.html',
  styleUrls: ['./component-registration-popup.component.css']
})
export class ComponentRegistrationPopupComponent implements OnInit {

    constructor(
      contentData: AimsCommonPopupEditorData,
      public authService: AuthService,
      public permissionsService: PermissionsService, 
      private transferHttp: TransferHttpService){
      this.isNew = contentData.isNew;
      this.compToEdit = contentData.contentData;
      this.formGroup = contentData.formGroup;

      this.formGroup.addControl('component', new FormControl(this.compToEdit.component, Validators.required));
      this.formGroup.addControl('parentComponentId', new FormControl(this.compToEdit.parentComponentId));
      this.formGroup.addControl('description', new FormControl(this.compToEdit.description, Validators.required));
    
    }
  compToEdit;
  header: string;
  isNew: boolean = false;
  public formGroup: any;
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],        // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }],          // outdent/indent
      [{ header: [3, 4, false] }],
      [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
      [{ align: [] }],
      ['clean']                                       // remove formatting button
    ]
};
  componentsDataSource: NgComponents[];
  components = this.permissionsService.getComponents()
  ngOnInit(): void {
  }

}
